module.exports = __webpack_public_path__ + "img/LogOut.6fbede9e.svg";